export class Setting {
    id: string;
    key: string;
    value: string;
    description: string;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/settings.ts